function s() {
  return !1;
}
var a = s;
export {
  a as s
};
//# sourceMappingURL=index.es401.js.map
